import { useModuleBEM } from "@b2bportal/core-themes";
import { Accordion } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

export type CollapsableSectionProps = {
  title: string;
  className?: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
};

export const CollapsableSection = ({
  title,
  className,
  children,
  defaultOpen,
}: CollapsableSectionProps) => {
  const [block, cn] = useModuleBEM(styles, "CollapsableSection");
  return (
    <Accordion
      items={[{ id: title, title, content: children }]}
      defaultValue={defaultOpen ? [title] : []}
      className={clsx(cn("section"), className)}
      itemClassName={cn("item")}
      triggerClassName={cn("trigger")}
      type="multiple"
    />
  );
};
